import AsControl from '../AsControl';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import autoSaved from '../../utils/hoc/formHelpers/autoSaved';
import { withTranslation } from '../Translator';
import { FilteredSelect as BaseFilteredSelect } from './FilteredSelect';

const TranslatedFilteredSelect = withTranslation('components')(BaseFilteredSelect);
TranslatedFilteredSelect.displayName = 'FilteredSelect';

export const FilteredSelect = AsControl()(TranslatedFilteredSelect);
export const FilteredSelectControl = bindControlToForm()(FilteredSelect);
export const AutoSavedFilteredSelectControl = autoSaved({ saveOnChange: true })(FilteredSelectControl);
